export default "<div *ngIf=\"active\">\n  <ng-content></ng-content>\n</div>\n"